import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { translationChunksConfig } from '@spartacus/assets';
import { I18nModule, provideConfig } from '@spartacus/core';
import { LocationStripComponent } from './location-strip.component';

@NgModule({
  declarations: [LocationStripComponent],
  imports: [CommonModule, RouterModule, I18nModule],
  exports: [LocationStripComponent],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: '../public/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class LocationStripModule {}
